import * as React from "react";
const Svg15Mp = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 14h1.5v1.5H15z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 3v18h18V3H3zm9 7h3V9h-3V5.5h4.5V7h-3v1h3v3.5H12V10zM7 5.5h3v6H8.5V7H7V5.5zm5.5 13H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5v6zM18 17h-3v1.5h-1.5v-6H18V17z",
  fill: "currentColor"
}));
export default Svg15Mp;